import { Card, CardContent, Typography, Container, Box, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PersonalCoachingIcon from './assets/personal-coaching.svg';
import LifeCoachingIcon from './assets/life-coaching.svg';
import ExecutiveCoachingIcon from './assets/executive-coaching.svg';

function ServicesSection() {
  const theme = useTheme();
  
  const services = [
    { 
      title: "Personal Coaching", 
      desc: "One-on-one sessions to unlock your potential.",
      icon: <img src={PersonalCoachingIcon} alt="Personal Coaching" style={{ width: '80px', height: '80px' }} />,
      color: theme.palette.secondary.main
    },
    { 
      title: "Life Coaching", 
      desc: "Collaborative learning and growth.",
      icon: <img src={LifeCoachingIcon} alt="Life Coaching" style={{ width: '80px', height: '80px' }} />,
      color: theme.palette.info.main
    },
    { 
      title: "Executive/Leadership Coaching", 
      desc: "Navigate your professional path.",
      icon: <img src={ExecutiveCoachingIcon} alt="Executive/Leadership Coaching" style={{ width: '80px', height: '80px' }} />,
      color: theme.palette.success.main
    },
  ];

  return (
    <Box 
      id="services"
      sx={{ 
      py: { xs: 6, md: 10 },
      bgcolor: 'background.paper',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h2" 
          component="h2" 
          align="center" 
          sx={{ 
            mb: 2,
            color: 'primary.main'
          }}
        >
          Our Services
        </Typography>
        
        <Typography 
          variant="h5" 
          component="p" 
          align="center" 
          sx={{ 
            mb: 6,
            color: 'text.secondary',
            maxWidth: '700px',
            mx: 'auto',
            px: { xs: 2, sm: 0 }
          }}
        >
          Empowering you with personalized coaching solutions for personal and professional growth.
        </Typography>

        <Grid container spacing={4} justifyContent="center" alignItems="stretch">
          {services.map((service, idx) => (
            <Grid 
              key={idx}
              sx={{
                width: { xs: '100%', sm: 'calc(50% - 20px)', md: 'calc(33.333% - 22px)' },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                p: 1
              }}
            >
              <Card 
                elevation={0}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100%',
                  minHeight: '320px',
                  borderRadius: 3,
                  border: `1px solid ${theme.palette.divider}`,
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: `0 12px 24px -8px ${theme.palette.primary.light}40`,
                    borderColor: 'transparent'
                  },
                  position: 'relative',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: service.color,
                    opacity: 0,
                    transition: 'opacity 0.3s ease-in-out'
                  },
                  '&:hover::before': {
                    opacity: 1
                  }
                }}
              >
                <CardContent 
                  sx={{ 
                    p: 4,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <Box 
                    sx={{ 
                      width: '100px',
                      height: '100px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 4,
                      '& img': {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        transition: 'transform 0.3s ease-in-out',
                      }
                    }}
                  >
                    {service.icon}
                  </Box>
                  
                  <Typography 
                    variant="h5" 
                    component="h3"
                    sx={{ 
                      mb: 2,
                      fontWeight: 700,
                      color: 'primary.main',
                      minHeight: '3em',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%'
                    }}
                  >
                    {service.title}
                  </Typography>
                  
                  <Typography 
                    variant="body1"
                    sx={{ 
                      color: 'text.secondary',
                      lineHeight: 1.7,
                      mb: 3,
                      flexGrow: 1,
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {service.desc}
                  </Typography>
                  
                  <Box 
                    sx={{
                      width: '40px',
                      height: '4px',
                      background: service.color,
                      borderRadius: '2px',
                      mt: 'auto',
                      opacity: 0.8
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default ServicesSection;
